import { render } from "./Ahtung.vue?vue&type=template&id=2939abfb"
import script from "./Ahtung.vue?vue&type=script&lang=js"
export * from "./Ahtung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__